// extracted by mini-css-extract-plugin
module.exports = {"post":"postSummary-module--post--3ZKNN","postTitle":"postSummary-module--postTitle--1WApM","link":"postSummary-module--link--AXKgC","image":"postSummary-module--image--1p9BK"};